export default __webpack_public_path__ + "static/media/roku.48da14fd.svg";